import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withCtx as _withCtx, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5e10cf94"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "app-container"
};
const _hoisted_2 = {
  class: "search-container"
};
const _hoisted_3 = {
  class: "search-left"
};
const _hoisted_4 = {
  class: "table-container-wrapper"
};
const _hoisted_5 = {
  class: "table-top-flex"
};
const _hoisted_6 = {
  class: "table-title"
};
const _hoisted_7 = {
  key: 0,
  class: "button-container"
};
import { ref, unref, reactive, toRefs, watch, onMounted, nextTick, computed } from "vue";
import { useRouter } from 'vue-router';
import { ElMessageBox, ElMessage } from 'element-plus';
import { loginLogList, exportLoginLog, delLogininfo, cleanLogininfo } from "@/api/system1/log";
import { download } from '@/utils/index';
export default {
  __name: 'index',
  setup(__props) {
    const router = useRouter();
    const ruleFormRef = ref(ElForm);
    const uploadRef = ref();

    // 获取路由名称作为表格标题
    const tableTitle = computed(() => {
      const route = router.currentRoute.value;
      return route.meta?.title || route.name || '登录日志';
    });
    const state = reactive({
      // 当前页签名称
      activeName: '待发通知',
      // 遮罩层
      loading: true,
      saveLoading: false,
      chnageFlag: false,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 模型表格数据
      list: {
        total: 0,
        rows: []
      },
      // 表单参数
      form1: {
        infoType: '',
        wechatGroupName: '',
        time: '是',
        releaseDateStr: '',
        infoCategory: '文字',
        fileUrl: '',
        fileRaw: null,
        releaseContent: '',
        remark: '',
        deptNames: '',
        courtsManageNames: ''
      },
      // 表格选中的数据
      currentSelectRows: [],
      // 查询参数
      queryParams: {
        pageSize: 10,
        pageNum: 1,
        startDate: '',
        endDate: '',
        originDate: [],
        userName: '',
        ipaddr: '',
        status: ''
      },
      uploadForm: {
        fileList: []
      },
      uploadFormRules: {
        fileList: [{
          required: true,
          message: "上传文件不能为空",
          trigger: "blur"
        }]
      },
      cloneQueryParams: null,
      searchFormData: [{
        prop: "userName",
        label: "用户账号",
        type: "text",
        placeholder: "请输入用户账号",
        span: 7
      }, {
        prop: "ipaddr",
        label: "登录IP地址",
        type: "text",
        placeholder: "请输入登录IP地址",
        span: 7
      }, {
        prop: "status",
        label: "登录状态",
        placeholder: "请选择状态",
        type: "list",
        isSelect: false,
        filterable: true,
        options: [{
          dictValue: '1',
          dictLabel: "失败"
        }, {
          dictValue: '0',
          dictLabel: "成功"
        }],
        props: {
          label: "dictLabel",
          value: "dictValue"
        },
        change: () => {},
        span: 4
      }, {
        prop: "originDate",
        label: "操作时间",
        type: "daterange",
        multiple: true,
        span: 7,
        change: val => {
          if (val?.length) {
            state.queryParams.startDate = val[0] + ' 00:00:00';
            state.queryParams.endDate = val[1] + ' 23:59:59';
          } else {
            state.queryParams.startDate = '';
            state.queryParams.endDate = '';
          }
        }
      }],
      formHandle: [{
        label: "搜索",
        type: "primary",
        class: "btn-liquid",
        handle: () => handleQuery()
      }, {
        label: "重置",
        icon: "Refresh",
        class: "commonDarkBtn",
        handle: () => resetQuery()
      }],
      //列表顶部顶部操作按钮数据
      buttonsList: [{
        buttonName: "导出",
        buttonStyle: "warning",
        hasPermi: ['system:logininfo:export'],
        className: 'exportBtn',
        buttonIcon: "Upload",
        exp: item => handleExport(item)
      }, {
        buttonName: "删除",
        buttonStyle: "danger",
        hasPermi: ['system:logininfo:remove'],
        className: 'deleteBtn',
        buttonIcon: "Delete",
        exp: item => handleDelete(item),
        disabledHandle(row) {
          return state.multiple;
        }
      }, {
        buttonName: "清空",
        buttonStyle: "danger",
        hasPermi: ['system:logininfo:qingkong'],
        className: 'deleteBtn',
        buttonIcon: "Delete",
        exp: item => handleQingkong()
      }],
      tableHeader: [{
        prop: "index",
        label: "序号"
      }, {
        prop: "userName",
        label: "用户账号"
      }, {
        prop: "ipaddr",
        label: "登录IP地址"
      }, {
        prop: "accessTime",
        label: "登录时间"
      }, {
        prop: "status",
        label: "登录状态",
        statusList: [{
          value: "1",
          label: "失败"
        }, {
          value: "0",
          label: "成功"
        }]
      }, {
        prop: "operation",
        label: "操作",
        width: "150px",
        fixed: "right",
        operation: [{
          name: '删除',
          clickFun: row => handleDelete(row),
          hasPermi: ['system:logininfo:remove']
        }]
      }],
      operation: '新增',
      //是否为编辑操作
      transName: '',
      transformer: '',
      // 表单参数
      form: {
        infoType: '',
        wechatGroupName: '',
        time: '是',
        releaseDateStr: '',
        infoCategory: '文字',
        fileUrl: '',
        fileRaw: null,
        releaseContent: '',
        remark: '',
        deptNames: '',
        courtsManageNames: ''
      },
      cloneForm: null,
      // 表单校验
      rules: {
        feeder: [{
          required: true,
          message: "不能为空",
          trigger: "change"
        }],
        wechatGroupName: [{
          required: true,
          message: "不能为空",
          trigger: "change"
        }],
        time: [{
          required: true,
          message: "不能为空",
          trigger: "change"
        }],
        releaseDateStr: [{
          validator: (rule, value, callback) => {
            if (value) {
              if (new Date(value).getTime() <= new Date().getTime()) {
                callback(new Error('选择的时间不能小于当前时间！'));
              } else {
                callback();
              }
            } else {
              callback(new Error('不能为空'));
            }
          },
          trigger: "change"
        }],
        infoType: [{
          required: true,
          message: "不能为空",
          trigger: "change"
        }],
        fileUrl: [{
          required: true,
          message: "不能为空",
          trigger: "change"
        }],
        releaseContent: [{
          required: true,
          message: "不能为空",
          trigger: "change"
        }]
      },
      formData1: [{
        prop: "userName",
        label: "用户账号",
        placeholder: "",
        type: "text",
        span: 24
      }, {
        prop: "ipaddr",
        label: "登录IP地址",
        placeholder: "",
        type: "text",
        span: 24
      }, {
        prop: "status",
        label: "登录状态（0成功 1失败）",
        placeholder: "",
        type: "text",
        span: 24
      }, {
        prop: "startDate",
        label: "开始时间",
        placeholder: "",
        type: "text",
        span: 24
      }, {
        prop: "endDate",
        label: "结束时间",
        placeholder: "",
        type: "text",
        span: 24
      }],
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      dialogVisible: false,
      dialogVisible1: false,
      typeUrl: ''
    });
    state.cloneQueryParams = JSON.parse(JSON.stringify(state.queryParams));
    state.cloneForm = JSON.parse(JSON.stringify(state.form));
    onMounted(() => {});
    const handleSelectionChange = function (selection) {
      state.ids = selection.map(item => item.infoId);
      state.single = selection.length != 1;
      state.multiple = !selection.length;
    };
    // 清空
    const handleQingkong = function () {
      ElMessageBox.close();
      ElMessageBox.confirm('是否确认清空登录日志?', "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        return cleanLogininfo();
      }).then(res => {
        getList();
        ElMessage.success("清空成功");
      }).catch(function () {});
    };
    /** 删除按钮操作 */
    const handleDelete = function (row) {
      const logIds = row.infoId || state.ids;
      ElMessageBox.close();
      ElMessageBox.confirm('是否确认删除数据项?', "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        return delLogininfo(logIds);
      }).then(res => {
        getList();
        ElMessage.success("删除成功");
      }).catch(function () {});
    };
    /** 导出文件 */
    const handleExport = function (row) {
      ElMessageBox.close();
      ElMessageBox.confirm('是否确认导出数据项?', "导出", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        exportLoginLog(state.queryParams).then(res => {
          if (res.status === 200) {
            let fileName = decodeURI(res.headers["content-disposition"].split("utf-8''")[1]);
            download(res.data, fileName);
          }
        }).catch(() => {});
      });
    };
    /** 查询列表 */
    const getList = function () {
      state.loading = true;
      let params = {
        ...state.queryParams
      };
      delete params.originDate;
      loginLogList(params).then(res => {
        if (res.code == 0) {
          state.list = {
            rows: res.data.list,
            total: res.data.total
          };
        }
      }).finally(() => {
        state.loading = false;
      });
    };

    /** 搜索按钮操作 */
    const handleQuery = function () {
      state.queryParams.pageNum = 1;
      getList();
    };
    /** 重置按钮操作 */
    const resetQuery = function () {
      state.queryParams = JSON.parse(JSON.stringify(state.cloneQueryParams));
      handleQuery();
    };
    return (_ctx, _cache) => {
      const _component_commonForm = _resolveComponent("commonForm");
      const _component_Iconfont = _resolveComponent("Iconfont");
      const _component_el_button = _resolveComponent("el-button");
      const _component_commonTable = _resolveComponent("commonTable");
      const _component_commonDrawer = _resolveComponent("commonDrawer");
      const _directive_hasPermi = _resolveDirective("hasPermi");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_commonForm, {
        form: state.queryParams,
        formData: state.searchFormData,
        formHandle: state.formHandle
      }, null, 8, ["form", "formData", "formHandle"])])]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createVNode(_component_Iconfont, {
        name: "ercishebeiliebiao",
        class: "table-title-icon"
      }), _createElementVNode("p", null, _toDisplayString(_unref(tableTitle)), 1)]), state.buttonsList.length ? (_openBlock(), _createElementBlock("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.buttonsList, (item, index) => {
        return _withDirectives((_openBlock(), _createBlock(_component_el_button, {
          key: index,
          class: _normalizeClass([item.className]),
          loading: item.loading,
          disabled: item.disabled,
          icon: item.buttonIcon,
          type: item.buttonStyle,
          onClick: $event => item.exp(item)
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(item.buttonName), 1)]),
          _: 2
        }, 1032, ["class", "loading", "disabled", "icon", "type", "onClick"])), [[_directive_hasPermi, item.hasPermi ? item.hasPermi : []]]);
      }), 128))])) : _createCommentVNode("", true)]), _withDirectives(_createVNode(_component_commonTable, {
        class: "flex-table",
        tableData: state.list,
        tableHeader: state.tableHeader,
        queryParams: state.queryParams,
        multipleSelection: state.ids,
        "onUpdate:multipleSelection": _cache[0] || (_cache[0] = $event => state.ids = $event),
        onGetList: getList,
        hasSelect: true,
        columnSetting: false,
        onSelectionChange: handleSelectionChange,
        rowKey: "infoId"
      }, null, 8, ["tableData", "tableHeader", "queryParams", "multipleSelection"]), [[_directive_loading, state.loading]])]), _createVNode(_component_commonDrawer, {
        modelValue: state.dialogVisible1,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => state.dialogVisible1 = $event),
        size: "30%",
        title: "员工详情",
        "close-on-click-modal": false,
        onClose: _ctx.clearForm1
      }, {
        footer: _withCtx(() => []),
        default: _withCtx(() => [_createVNode(_component_commonForm, {
          ref: "formContainer1",
          form: state.form1,
          formData: state.formData1,
          isDetail: true,
          isHandle: false
        }, null, 8, ["form", "formData"])]),
        _: 1
      }, 8, ["modelValue", "onClose"])]);
    };
  }
};